import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { Conversation } from 'src/app/interfaces/conversation';
import { WebSocketService } from 'src/app/services/web-socket.service';
import { conversationSteps, Steps } from '../../constants/constants';
import { BrowserStorageService } from '../../services/browser-storage.service';

@Component({
  selector: 'app-chat-tile',
  templateUrl: './chat-tile.component.html',
  styleUrls: ['./chat-tile.component.scss'],
})
export class ChatTileComponent implements OnInit, OnDestroy {
  @Input() conversation!: Conversation;

  get conversationStep():
    | {
        name: string;
        value: Steps;
        label: string;
        icon: string;
      }
    | undefined {
    return this.getConversationStep(this.conversation.step);
  }

  private socketSubscription?: Subscription;
  private storageManager: BrowserStorageService = new BrowserStorageService();

  constructor(private webSocketService: WebSocketService) {}
  ngOnInit(): void {
    this.socketSubscription = this.webSocketService.messages$?.subscribe({
      next: msg => {
        if (msg.action === 'is_assistance_required') {
          if (
            this.conversation.phone === msg.phone &&
            this.conversation.id === msg.conversationId
          ) {
            this.conversation.is_assistance_required = msg.status;
          }
        }
        if (msg.action === 'is_bot_disabled') {
          if (
            this.conversation.phone === msg.phone &&
            this.conversation.id === msg.conversationId
          ) {
            this.conversation.is_bot_enabled = msg.status;
          }
        }
        if (msg.step) {
          if (this.conversation.id === msg.conversationId) {
            this.conversation.step = msg.step;
          }
        }
      },
    });
  }
  ngOnDestroy(): void {
    this.socketSubscription?.unsubscribe();
  }
  selectedConversation() {
    const selectedConversation: Conversation = JSON.parse(
      this.storageManager.get('selectedConversation', 'session') as string
    );
    if (this.conversation.phone === selectedConversation.phone) {
      return true;
    } else {
      return false;
    }
  }
  truncate(name: string) {
    return name.length > 23 ? `${name.substring(0, 23)}...` : name;
  }
  getConversationStep(stepValue: number):
    | {
        name: string;
        value: Steps;
        label: string;
        icon: string;
      }
    | undefined {
    return conversationSteps.find(stepItem => stepItem.value === stepValue);
  }
}
